import moment from "moment"
import React, { useEffect, useState } from "react"
import { updateBookingStatus } from "../../axios/api/apiModule"
import { useDispatch } from "react-redux"
import { openToastify } from "../store/actions/toastifyAction"
import Loader from "../asserts/Spin.gif"
import { REDUX_STORE_DEFAULTS, REDUX_TOASTIFY_DEFAULTS } from "../store/config"

const ViewBooking = (props) => {
  const { data, onClick, onEdit } = props
  const [isCopied, setIsCopied] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isBookingData, setIsBookingData] = useState({})
  const dispatch = useDispatch()

  useEffect(() => {
    setIsBookingData(data)
    console.log(data, "========", props)
  }, [data])

  const hitUpdateBookingStatusApi = async (id, status) => {
    try {
      const payload = {
        id: id,
        status: status,
      }
      setIsLoading(true)
      const response = await updateBookingStatus(payload)

      if (response.success) {
        setIsBookingData((data) => ({ ...data, bookingStatus: status }))

        dispatch(
          openToastify(
            response.msg,
            REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_SUCCESS(),
          ),
        )
      }

      console.log(response)
    } catch (error) {
      console.log(error)
      dispatch(
        openToastify(
          error?.response?.data?.message || "Error updateing status",
          REDUX_TOASTIFY_DEFAULTS.UPDATE_TOASTIFY_ERROR(),
        ),
      )
    } finally {
      setIsLoading(false)
    }
  }

  const getStatusColor = (status, location, isAppbooking) => {
    const statusColors = {
      pending: "bg-[#F6BF26]", // banana
      processing: "bg-[#E67C73]", // flamingo
      confirmed:
        location === "shop"
          ? isAppbooking
            ? "bg-[#0B8043]" // basil
            : "bg-[#33B679]" // sage
          : isAppbooking
            ? "bg-[#3F51B5]" // blueberry
            : "bg-[#039BE5]", // peacock
      completed: "bg-[#616161]", // graphite
      cancelled: "bg-[#D50000]", // tomato
    }

    return statusColors[status] || "#7986CB" // default lavender
  }

  // handle copy booking
  const handleCopy = async () => {
    if (!data) return

    // Build a nicely formatted string for sharing with employees
    const servicesText = data?.booking
      ?.map((b, i) => {
        // Extract vehicle type
        const vehicle = b.service?.serviceOption || "N/A"

        // Main service line with vehicle details
        const mainService = `${i + 1}. 🚗 Vehicle: *${vehicle}*\n   🛠 Service: ${b.service?.categoryName} - ${b.service?.packageName} ($${b.servicePrice})`

        // Add-ons list
        const addons =
          b.addonService && b.addonService.length > 0
            ? b.addonService
                .map(
                  (a) =>
                    `   • Add-on: ${a.addonServiceName} ($${a.addonPrice || a.addonSalePrice})`,
                )
                .join("\n")
            : "   • No add-ons"

        return `${mainService}\n${addons}`
      })
      .join("\n\n")

    const shareableText = `
📌 *JOB DISPATCH - #${isBookingData?.shortBookingId}*
Status: ${isBookingData?.bookingStatus?.toUpperCase()}

📅 *Date & Time:*
${
  data?.bookingDate && data?.bookingSlot
    ? moment
        .tz(
          `${isBookingData.bookingDate} ${isBookingData.bookingSlot}`,
          "YYYY-MM-DD HH:mm",
          "America/Vancouver",
        )
        .format("DD MMM YYYY, hh:mm A")
    : "N/A"
}

👤 *Customer:*
Name: ${isBookingData?.firstName} ${isBookingData?.lastName}
📞 Phone: ${isBookingData?.phoneNumber}

📍 *Location Info:*
Type: ${isBookingData?.locationType?.toUpperCase()}
Address: ${isBookingData?.location}

⚡ *On-Site Requirements:*
💧 Water Provided: ${isBookingData?.isWaterAvailable ? "✅ Yes" : "❌ No"}
🔌 Power Provided: ${isBookingData?.isElectricityAvailable ? "✅ Yes" : "❌ No"}

🧾 *Services to Perform:*
${servicesText || "No services listed"}

💰 *Amount to Collect:* $${isBookingData?.totalAmount}

📝 *Customer Note:*
${isBookingData?.note || "N/A"}

📝 *Additional Note:*
${isBookingData?.additionalNote || "N/A"}
    `.trim()

    try {
      await navigator.clipboard.writeText(shareableText)
      setIsCopied(true)
      // Reset the button after 2 seconds
      setTimeout(() => setIsCopied(false), 2000)
    } catch (err) {
      console.error("Failed to copy details: ", err)
    }
  }

  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 backdrop-blur-sm p-4 sm:p-6">
        {/* Modal Container */}
        <div className="bg-gray-50 w-full max-w-5xl max-h-[95vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden relative border border-gray-200">
          {/* Header (Sticky) */}
          <div className="bg-white px-6 py-4 border-b border-gray-200 flex justify-between items-center sticky top-0 z-10">
            <div>
              <h2 className="text-xl font-bold">
                Booking #{isBookingData.shortBookingId}
              </h2>

              {/* Booking Meta */}
              <div className="flex items-center gap-4 text-gray-500 mt-1">
                <span>📅 {isBookingData.bookingDate}</span>
                <span>
                  ⏰{" "}
                  {moment
                    .tz(isBookingData.bookingSlot, "HH:mm", "America/Vancouver")
                    .format("hh:mm A")}
                </span>
                <span>{isBookingData.isAppbooking ? "📱 App" : "🌐 Web"}</span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {/* Status */}
              <select
                value={isBookingData?.bookingStatus}
                onChange={(e) =>
                  hitUpdateBookingStatusApi(isBookingData._id, e.target.value)
                }
                className={`px-4 py-1 rounded-full text-sm font-semibold text-white capitalize outline-none cursor-pointer ${getStatusColor(
                  isBookingData.bookingStatus,
                  isBookingData.locationType,
                  isBookingData.isAppbooking,
                )}`}
              >
                <option className="bg-white text-black" value="pending">
                  Pending
                </option>
                <option className="bg-white text-black" value="processing">
                  Processing
                </option>
                <option className="bg-white text-black" value="confirmed">
                  Confirmed
                </option>
                <option className="bg-white text-black" value="completed">
                  Completed
                </option>
                <option className="bg-white text-black" value="cancelled">
                  Cancelled
                </option>
              </select>

              <div className="flex gap-2">
                <button
                  onClick={() => onEdit()}
                  className="p-2 bg-gray-100 text-gray-600 hover:bg-blue-100 hover:text-blue-600 rounded-full transition-colors duration-200"
                  title="Edit"
                >
                  {/* Edit SVG Icon */}
                  <svg
                    className="w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M16.862 3.487a2.25 2.25 0 113.182 3.182L7.5 19.213 3 20.25l1.037-4.5L16.862 3.487z"
                    />
                  </svg>
                </button>
                <button
                  onClick={handleCopy}
                  className={`p-2 rounded-full transition-colors duration-200 ${
                    isCopied
                      ? "bg-green-100 text-green-700 hover:bg-green-200"
                      : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                  }`}
                  title={isCopied ? "Copied!" : "Copy Details"}
                >
                  {isCopied ? (
                    /* Tick (Checkmark) Icon */
                    <svg
                      className="w-5 h-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    /* Copy Icon */
                    <svg
                      className="w-5 h-5"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="2"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                      />
                    </svg>
                  )}
                </button>

                <button
                  onClick={onClick}
                  className="p-2 bg-gray-100 text-gray-600 hover:bg-red-100 hover:text-red-600 rounded-full transition-colors duration-200"
                  title="Close"
                >
                  {/* Close Icon */}
                  <svg
                    className="w-5 h-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Body (Scrollable) */}
          <div className="flex-1 overflow-y-auto p-6 space-y-6">
            {/* Top Grid: Personal & Booking Info */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Personal Details Card */}
              <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4 border-b pb-2">
                  Customer Details
                </h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Name</span>
                    <span className="font-medium text-gray-900 capitalize">
                      {isBookingData?.firstName} {isBookingData?.lastName}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Phone</span>
                    <span className="font-medium text-gray-900">
                      {isBookingData?.phoneNumber}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Email</span>
                    <span className="font-medium text-gray-900">
                      {isBookingData?.email}
                    </span>
                  </div>
                  <div className="flex justify-between items-start gap-4">
                    <span className="text-gray-500 min-w-[60px]">Location</span>
                    <span className="font-medium text-gray-900 text-right line-clamp-2">
                      {isBookingData?.location}
                    </span>
                  </div>
                </div>
              </div>

              {/* Booking Details Card */}
              <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4 border-b pb-2">
                  Appointment Info
                </h3>
                <div className="space-y-3 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-500">Location Type</span>
                    <span className="font-medium text-gray-900 capitalize">
                      {isBookingData?.locationType}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Date</span>
                    <span className="font-medium text-gray-900">
                      {isBookingData?.bookingDate && data?.bookingSlot
                        ? moment
                            .tz(
                              `${isBookingData.bookingDate} ${isBookingData.bookingSlot}`,
                              "YYYY-MM-DD HH:mm",
                              "America/Vancouver",
                            )
                            .format("dddd - MMMM Do, YYYY")
                        : "-"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Time</span>
                    <span className="font-medium text-gray-900">
                      {isBookingData?.bookingDate && data?.bookingSlot
                        ? moment
                            .tz(
                              `${isBookingData.bookingDate} ${isBookingData.bookingSlot}`,
                              "YYYY-MM-DD HH:mm",
                              "America/Vancouver",
                            )
                            .format("hh:mm A")
                        : "-"}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-500">Utilities</span>
                    <span className="font-medium text-gray-900 flex gap-2">
                      {isBookingData?.isWaterAvailable && (
                        <span className="bg-blue-50 text-blue-600 px-2 py-0.5 rounded text-xs">
                          Water
                        </span>
                      )}
                      {isBookingData?.isElectricityAvailable && (
                        <span className="bg-yellow-50 text-yellow-600 px-2 py-0.5 rounded text-xs">
                          Power
                        </span>
                      )}
                    </span>
                  </div>
                  {/* Assigned Employees */}
                  {isBookingData?.empAssigned?.length > 0 && (
                    <div className="flex justify-between items-start">
                      <span className="text-gray-500">Assigned To</span>

                      <div className="flex flex-wrap gap-2 justify-end">
                        {isBookingData.empAssigned.map((emp, i) => (
                          <span
                            key={emp._id || i}
                            className="bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded text-xs font-medium"
                          >
                            {emp.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Services Section */}
            <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
              <h3 className="text-sm font-bold text-gray-400 uppercase tracking-wider mb-4 border-b pb-2">
                Service Details
              </h3>
              <div className="space-y-6">
                {isBookingData?.booking?.map((value, index) => (
                  <div
                    key={index}
                    className="bg-gray-50 rounded-lg p-4 border border-gray-100"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between md:justify-start md:gap-4">
                          <span className="text-gray-500 w-28">
                            Vehicle Type:
                          </span>
                          <span className="font-semibold text-gray-900 capitalize">
                            {value?.service?.serviceOption}
                          </span>
                        </div>
                        <div className="flex justify-between md:justify-start md:gap-4">
                          <span className="text-gray-500 w-28">Category:</span>
                          <span className="font-semibold text-gray-900 capitalize">
                            {value?.service?.categoryName}
                          </span>
                        </div>
                      </div>
                      <div className="space-y-2 text-sm">
                        <div className="flex justify-between md:justify-start md:gap-4">
                          <span className="text-gray-500 w-28">Package:</span>
                          <span className="font-semibold text-gray-900 capitalize">
                            {value?.service?.packageDescription}
                          </span>
                        </div>
                        <div className="flex justify-between md:justify-start md:gap-4">
                          <span className="text-gray-500 w-28">Price:</span>
                          <span className="font-semibold text-gray-900">
                            ${value?.service?.packagePrice}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Addons List */}
                    {value?.addonService?.length > 0 && (
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <p className="text-xs font-bold text-gray-400 uppercase mb-2">
                          Add-ons
                        </p>
                        <div className="space-y-2">
                          {value.addonService.map((addon, idx) => (
                            <div
                              key={idx}
                              className="flex justify-between text-sm bg-white p-2 rounded border border-gray-100"
                            >
                              <span className="text-gray-700 capitalize">
                                {addon?.addonServiceName}
                              </span>
                              <span className="font-medium text-gray-900">
                                ${addon?.addonPrice}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Images (Replaced invalid <tr> tags) */}
                    {value?.images?.length > 0 && (
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <p className="text-xs font-bold text-gray-400 uppercase mb-2">
                          Uploaded Images
                        </p>
                        <div className="flex gap-4 overflow-x-auto pb-2 snap-x">
                          {value.images.map((url, i) => (
                            <img
                              key={i}
                              src={url}
                              alt={`Upload ${i}`}
                              className="w-40 h-28 object-cover rounded-lg shadow-sm border border-gray-200 snap-center shrink-0"
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom Grid: Notes & Billing */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* Notes Section */}
              <div className="lg:col-span-2 space-y-4">
                {(data?.note || data?.additionalNote) && (
                  <div className="bg-blue-50/50 p-5 rounded-xl border border-blue-100 h-full">
                    <h3 className="text-sm font-bold text-blue-800 uppercase tracking-wider mb-3">
                      Notes & Instructions
                    </h3>
                    {isBookingData?.note && (
                      <div className="mb-3">
                        <span className="text-xs font-bold text-blue-600 block mb-1">
                          Customer Note:
                        </span>
                        <p className="text-sm text-gray-700 bg-white p-3 rounded-lg border border-blue-50">
                          {isBookingData.note}
                        </p>
                      </div>
                    )}
                    {isBookingData?.additionalNote && (
                      <div>
                        <span className="text-xs font-bold text-blue-600 block mb-1">
                          Additional Note:
                        </span>
                        <p className="text-sm text-gray-700 bg-white p-3 rounded-lg border border-blue-50">
                          {isBookingData.additionalNote}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* Bill/Receipt Section */}
              <div className="bg-gray-800 text-white p-6 rounded-xl shadow-lg relative overflow-hidden">
                {/* Decorative Receipt Edge */}
                <div className="absolute top-0 left-0 right-0 h-2 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiPjxwb2x5Z29uIHBvaW50cz0iMCwwIDQsOCA4LDAiIGZpbGw9IiNmOWZhZmIiLz48L3N2Zz4=')] repeat-x"></div>

                <h3 className="text-lg font-bold mb-4 mt-2">Order Summary</h3>
                <div className="space-y-2 text-sm text-gray-300">
                  <div className="flex justify-between">
                    <span>Service Total</span>
                    <span className="text-white">
                      ${isBookingData?.serviceTotal}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>Add-ons Total</span>
                    <span className="text-white">
                      ${isBookingData?.addonServiceTotal}
                    </span>
                  </div>

                  {/* Conditionally render Electricity Bill if it applies */}
                  {!data?.isElectricityAvailable &&
                    data?.electricityBill > 0 && (
                      <div className="flex justify-between">
                        <span>Power Surcharge</span>
                        <span className="text-white">
                          ${isBookingData?.electricityBill}
                        </span>
                      </div>
                    )}

                  <div className="border-t border-gray-600 my-2 pt-2 flex justify-between font-medium">
                    <span>Sub Total</span>
                    <span className="text-white">
                      ${isBookingData?.subTotal}
                    </span>
                  </div>

                  {/* Discounts */}
                  {(data?.couponDiscountAmount > 0 ||
                    data?.giftCardDiscountAmount > 0) && (
                    <div className="text-emerald-400 space-y-1 py-1">
                      {isBookingData?.couponDiscountAmount > 0 && (
                        <div className="flex justify-between">
                          <span>Coupon Discount</span>
                          <span>-${isBookingData?.couponDiscountAmount}</span>
                        </div>
                      )}
                      {isBookingData?.giftCardDiscountAmount > 0 && (
                        <div className="flex justify-between">
                          <span>Gift Card</span>
                          <span>-${isBookingData?.giftCardDiscountAmount}</span>
                        </div>
                      )}
                    </div>
                  )}

                  <div className="flex justify-between pb-3">
                    <span>Tax ({isBookingData?.tax}%)</span>
                    <span className="text-white">
                      ${isBookingData?.taxAmount}
                    </span>
                  </div>

                  {/* Grand Total */}
                  <div className="border-t-2 border-dashed border-gray-500 pt-3 mt-3 flex justify-between items-center">
                    <span className="text-base font-bold text-white uppercase tracking-wider">
                      Total
                    </span>
                    <span className="text-2xl font-bold text-white">
                      ${isBookingData?.totalAmount}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <div className=" absolute inset-0 z-50 flex justify-center items-center backdrop-blur-sm">
          <img src={Loader} alt="" className="size-12" />
        </div>
      ) : (
        <></>
      )}
    </>
  )
}

export default ViewBooking
